import { RouterProvider } from 'react-router/dom';
import { router } from './routes/AppRouter';
import { ShortcutProvider } from 'react-keybind';
import ThemeProvider from './context/theme/ThemeProvider';
import BetaGuard from './layouts/BetaGuard';
import { useMemo } from 'react';
import NavbarNotificationProvider from './context/navbarNotification/NavbarNotificationProvider';
import AppProvider from './context/app/AppProvider';
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ms from 'ms';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: ms('2h'),
            gcTime: ms('2h') + ms('5m'),
            retry: false,
            placeholderData: keepPreviousData,
        },
    },
});

export default function App() {
    const appRouter = useMemo(() => router(queryClient), []);

    return (
        <QueryClientProvider client={queryClient}>
            <AppProvider>
                <NavbarNotificationProvider>
                    <ShortcutProvider>
                        <ThemeProvider>
                            <BetaGuard>
                                <RouterProvider router={appRouter} />
                            </BetaGuard>
                        </ThemeProvider>
                    </ShortcutProvider>
                </NavbarNotificationProvider>
            </AppProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
